import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl, FormattedMessage } from 'react-intl-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { getTruncateStyles } from '../../utils';
import { selectUnit } from '@formatjs/intl-utils';
import { messages } from '../../../../../messages';
var styles = css({
  color: "var(--ds-text-subtlest, #626F86)",
  fontSize: '0.75rem',
  lineHeight: '1rem'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
getTruncateStyles(1));
var typeToDescriptorMap = {
  created: {
    relative: messages.created_on_relative,
    absolute: messages.created_on_absolute
  },
  modified: {
    relative: messages.modified_on_relative,
    absolute: messages.modified_on_absolute
  },
  sent: {
    relative: messages.sent_on_relative,
    absolute: messages.sent_on_absolute
  }
};

/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */
var DateTime = function DateTime(_ref) {
  var date = _ref.date,
    name = _ref.name,
    overrideCss = _ref.overrideCss,
    type = _ref.type,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-date-time' : _ref$testId,
    text = _ref.text;
  var _useIntl = useIntl(),
    formatRelativeTime = _useIntl.formatRelativeTime,
    formatDate = _useIntl.formatDate;
  if (!type || !date) {
    return null;
  }
  var isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 1000 * 60 * 60 * 24 * 7;
  var context;
  var typeVariant;
  if (isLongerThenWeek) {
    typeVariant = 'absolute';
    context = formatDate(date, {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } else {
    var _selectUnit = selectUnit(date, Date.now()),
      value = _selectUnit.value,
      unit = _selectUnit.unit;
    typeVariant = 'relative';
    context = formatRelativeTime(value, unit, {
      numeric: 'auto'
    });
  }
  return jsx("span", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    css: [styles, overrideCss],
    "data-separator": true,
    "data-smart-element": name,
    "data-smart-element-date-time": true,
    "data-testid": testId
  }, text ? "".concat(text, " ").concat(context) : jsx(FormattedMessage, _extends({}, typeToDescriptorMap[type][typeVariant], {
    values: {
      context: context
    }
  })));
};
export default DateTime;